import { useDocumentTypes } from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.hooks';
import ColumnFilter from '../../ColumnFilter';
import { useState } from 'react';
import { useDebouncedOnChange } from '@/hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { Button } from 'antd';
import {
  DocumentType,
  ListDocumentTypesQuery,
} from '@/core/domain/enterprise/DocumentTypes/DocumentTypes.types';

interface Props {
  onChange(value: number, item: DocumentType): void;
  value?: number;
  queryFilter?: ListDocumentTypesQuery;
}

const DocumentTypeColumnFilter: React.FC<Props> = (props) => {
  const [search, setSearch] = useState('');
  const [value, setValue] = useState();

  const onSearch = useDebouncedOnChange(setSearch);

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useDocumentTypes({
      active: true,
      description: search,
      ...props.queryFilter,
    });

  const dataSource = flatInfiniteData(data);

  return (
    <ColumnFilter
      loading={isLoading}
      onSearch={onSearch}
      onChange={(value) => {
        const documentType = dataSource.find(
          (item) => item.id === value,
        ) as DocumentType;

        props.onChange(value, documentType);
        setValue(value);
      }}
      value={props.value || value}
      dataSource={dataSource.map((item) => ({
        value: item.id,
        label: item.description,
      }))}
      footer={
        hasNextPage && (
          <Button
            type="primary"
            block
            loading={isFetching}
            onClick={() => fetchNextPage()}
          >
            Carregar mais
          </Button>
        )
      }
    />
  );
};

export default DocumentTypeColumnFilter;
